import { ChangeDetectionStrategy, Component, Input, Signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Summary } from 'src/app/models/summary.model';
import { InfoButtonComponent } from '../info-button/info-button.component';

@Component({
  selector: 'vti-summary-table',
  standalone: true,
  imports: [CommonModule, InfoButtonComponent],
  templateUrl: './summary-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryTableComponent {
  @Input({ required: true }) public summary!: Signal<Summary | null>;

  public utilitiesService = inject(UtilitiesService);
  public locale = this.utilitiesService.locale;
}
